import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalstorageService {

  constructor() {}

  /**
   * Get the stored value from localStorage by key
   * @param key - The key for the item in localStorage
   * @returns Parsed data from localStorage or undefined if not found
   */
  getData(key: string): any {
    return localStorage.getItem(key);
  }

  /**
   * Save a key-value pair in localStorage
   * @param key - The key for the item
   * @param obj - The object to store
   */
  saveData(key: string, obj: any): void {
    localStorage.setItem(key, obj);
  }

  /**
   * Remove an item from localStorage by key
   * @param key - The key for the item to remove
   */
  deleteData(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * Clear all data from localStorage
   */
  clearAllData(): void {
    localStorage.clear();
  }
}
